import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjeToPta } from 'src/app/shared/models/ProjetToPta';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-add-sous-activit-to-activite',
  templateUrl: './add-sous-activit-to-activite.component.html',
  styleUrl: './add-sous-activit-to-activite.component.scss'
})

export class AddSousActivitToActiviteComponent {

  item: any;
  isLoading: boolean = false;

  firstProjets = 0;
  rowsProjets = 10;
totalRecords: number = 0; // Nombre total d'éléments
  paginatedProjets = [];
  sousActiviteItemsToProjet:any;
  @ViewChild('sousActiviteModal') modalContent: TemplateRef<any>;
  newItem:ProjeToPta = new ProjeToPta();

  updateItem:ProjeToPta = new ProjeToPta();
  constructor(
 
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private confirmationService: ConfirmationService,
    private modalService: NgbModal,
    private router: Router,

  ) { }


  ngOnInit() {


    this.item = this.localStorage.getProjetActivite();

    //console.log("les item", this.item);

    this.getSousActiviteToProjet()

  }



  getSousActiviteToProjet() {
    //console.log("this.item", this.item.reference);
    this.isLoading = true;
  
    this.paramService.getSousActiviteToActivite(this.item.reference).subscribe(
      (response: any) => {
        //console.log("la reponse du webservice", response);
  
        this.sousActiviteItemsToProjet = response.data;
        this.totalRecords = this.sousActiviteItemsToProjet.length; // Met à jour le total des enregistrements
        this.updatePaginatedProjets();
        this.isLoading = false;
      },
      (error) => {
        //console.log("une erreur est survenue", error);
        this.isLoading = false;
      }
    );
  }
  //save

  saveSousActiviteToActivite() {

    this.newItem.pta_activite_id = this.item.reference;

    //console.log('this.newItem.projetId',this.newItem.projet_id);
    
    this.ngxService.start();
    this.paramService.saveSousActiviteToActivite(this.newItem).subscribe(

      (response: any) => {
        this.sousActiviteItemsToProjet = response.data;

        //console.log(" this.activiteItems", this.sousActiviteItemsToProjet);

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.newItem = new ProjeToPta();

        this.getSousActiviteToProjet();
        this.ngxService.stop();
      },
      (error) => {

        //console.log("une erreur est survenu", error);
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail:"une erreur est survenu" });


      }
    )
  }

  //end



  confirmDeletion(project: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer  cette sous-activitée ' + project.sous_activite + '?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramService.deleteSousActiviteToActivite(project.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            //console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getSousActiviteToProjet();
          },
          (error) => {
            this.ngxService.stop();
            //console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });
          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }

  close(){

    this.modalService.dismissAll();
  }


  pta_sous_sactivite_id :any
  openModalTache(sousActivite: any) {
    //console.log("sousActivite", sousActivite);

    this.updateItem = sousActivite;

    // Convertir la date_debut au format 'YYYY-MM-DD'
    this.updateItem.date_debut = sousActivite.date_debut.split('T')[0];
    this.updateItem.date_fin = sousActivite.date_fin.split('T')[0];

    //console.log("this.updateItem.date_debut", this.updateItem.date_debut);
    
    // Ouvrir le modal en passant le template
    this.updateItem.pta_activite_id = this.item.reference;

     this.pta_sous_sactivite_id = sousActivite.reference;
    //console.log("this.updateItem.pta_activite_id", this.updateItem.pta_activite_id);
    
    this.modalService.open(this.modalContent, {
       size: 'ml',
       backdrop: 'static',
       keyboard: false
    });
}




  updateSousActiviteToActivite(){
    //console.log('this.newItem.projetId',this.updateItem);

    this.ngxService.start();
    this.paramService.UpdateSousActiviteToActivite(this.pta_sous_sactivite_id , this.updateItem).subscribe(

      (response: any) => {

        //console.log(" this.activiteItems", response);

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

        this.getSousActiviteToProjet();
        this.modalService.dismissAll()
        this.ngxService.stop();
      },
      (error) => {

        //console.log("une erreur est survenu", error);
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail:"une erreur est survenu" });


      }
    )
  }

  addSousTacheToSousActivite(item: any) {

    //console.log("item");

    this.localStorage.saveTacheSousActiviteToActivité(item);
    
    this.router.navigate(['/suivi/planification/sous-activite-tache'])
  }

  
  onPageChangeProjets(event) {
    this.firstProjets =  event.first; // Mise à jour de la page actuelle
    this.rowsProjets =  event.rows; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }
  
  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.sousActiviteItemsToProjet.slice(start, end);
  }

}
